// @flow
import Fuse from 'fuse.js'

export const dynamicToFixed = (
  number: number,
  toFixedLength: number = 2
): string => {
  return Number(number)
    .toFixed(toFixedLength)
    .replace('.', ',')
    .replace(/([.,]00|0)$/, '')
}

export const sortArray = (
  arr: Array<Object>,
  options: { sortDir?: ?string, sortRow?: ?string }
): Array<Object> => {
  let { sortDir, sortRow } = options
  if (!sortDir) sortDir = 'DESC'
  if (!sortRow) sortRow = 'value'

  const propsExist = (v1, v2) => v1 && v2

  const numCompare = (v1, v2) =>
    propsExist(v1, v2) ? Number(v1) - Number(v2) : -1
  const strCompare = (v1, v2) =>
    propsExist(v1, v2) ? String(v1).localeCompare(String(v2)) : -1

  switch (sortDir) {
    case 'DESC':
      if (sortRow === 'name') {
        return arr.sort((a, b) => strCompare(b[sortRow], a[sortRow]))
      }
      return arr.sort((a, b) => numCompare(b[sortRow], a[sortRow]))
    case 'ASC':
      if (sortRow === 'name') {
        return arr.sort((a, b) => strCompare(a[sortRow], b[sortRow]))
      }
      return arr.sort((a, b) => numCompare(a[sortRow], b[sortRow]))
    default:
      return arr
  }
}

export const filterList = (
  value: string,
  list: Array<Object>
): Array<Object> => {
  const fuse = new Fuse(list, {
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.2,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ['name']
  })

  const result = fuse.search(value)
  return result
}

export const numberToPercentString = (num: number) => {
  const str = String(num).replace(/\.(?=[^.]*$)/g, ',')
  return `${str} %`
}



// WEBPACK FOOTER //
// ./src/shared/utils/sort/sort.js